import { useState } from "react";
import axios from "axios";
import "../../styles/customComponents/switchbtn.css";
import toast from "react-hot-toast";
import mainAxios from "../../redux/api/mainAxios";

const SwitchButton = ({
  isActive,
  itemId,
  onToggle = null,
  endpoint = "api/api-listes",
  fieldName = "",
  synchable = false,
}) => {
  const [loading, setLoading] = useState(false);
  const [currentActive, setCurrentActive] = useState(isActive);

  const handleToggle = async () => {
    const token = localStorage.getItem("token");
    setLoading(true);
    let newStatus;
    if (synchable) {
      newStatus = currentActive;
    } else {
      newStatus = !currentActive;
    }
    try {
      await mainAxios.put(
        `${endpoint}/${itemId}`,
        {
          data: {
            [fieldName]: newStatus,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (synchable) {
        setCurrentActive(!newStatus);
      } else {
        setCurrentActive(newStatus);
      }
      onToggle && onToggle(newStatus);

      toast.success("Mise à jour réussie");
    } catch (error) {
      console.error("Error toggling status", error);
      toast.error("Erreur lors de la mise à jour");

      setCurrentActive(currentActive);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`switch-button ${currentActive ? "active" : "inactive"} ${
        loading ? "loading" : ""
      }`}
      onClick={handleToggle}
    >
      <div className="switch-knob"></div>
    </div>
  );
};

export default SwitchButton;
